module.exports = __webpack_public_path__ + "img/yellowTran.4938b0be.png";